import DOMPurify from "dompurify";

DOMPurify.setConfig({ ADD_ATTR: ["target"] });

export const sanitize = (value) => {
  return value || value === "" ? DOMPurify.sanitize(value) : null;
};

/**
 * Remove HTML TAG
 * @param {string} value
 * @returns {string}
 */
export const stripTag = (value) => {
  return value?.replace(/<[^>]*>?/gm, "");
};

export default {
  sanitize,
  stripTag,
};
